export var Name = 'user-registered';
export var UserRegistered = Name;